











































































import { Vue, Component } from "vue-property-decorator";
import MyForm from "../MyForm";
import router from '../router';

@Component({})
export default class Register extends Vue {
  public form = new MyForm({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    password_confirmation: ""
  });

  register() {
     this.$store.dispatch('register/register', this.form)
     .then(() => {
       this.form.reset();
         router.push('/registration-confirmation')
         
     })
     .catch(error => {
       this.form.error = error.response.data.errors;
     })
  }
}
